import service from './index'

const resourceRunmetrix = service.resource('runmetrix/all-runmetrix/{runnerId}{ = page}{ = size}{= sort}')


export default { 

    getAllRunmetrixByRunnerId(runnerId,page,size) {
        return resourceRunmetrix.get({runnerId,page:page,size:size,sort:"date,Asc"})  
    }

}



// WEBPACK FOOTER //
// ./src/services/runmetrix.js